import { derived } from 'svelte/store';

import type { ProviderCalendar, SelectedCalendarsView } from '@repo/common';
import { createStoreHandle } from '../utils/store.util';
import { providerCalendars } from './provider.calendars.store';
import { waitForAuthAndUserId } from './waitForAuth';

const FILENAME = '.selected.calendars.dat';

const dummyCalendars: SelectedCalendarsView = {
  disabledCalendarIds: []
};

// Create the calendar store handle
const {
  store: _selectedCalendarsViewDataModel,
  itemStore: selectedCalendarsView,
  setItem: setSelectedCalendarsView,
  resetItem: _resetSelectedCalendarsView,
  loadStoredItem: loadStoredSelectedCalendars
} = createStoreHandle<SelectedCalendarsView>(FILENAME, dummyCalendars);

// Safe wrapper function that ensures user ID is set before loading
const safeLoadStoredSelectedCalendars = async (force: boolean = false, reload: boolean = false) => {
  try {
    // Wait for authentication and user ID to be ready
    await waitForAuthAndUserId().catch((err) => {
      console.debug('Error waiting for auth and user id:', err);
      return;
    });

    console.log(
      '[selected.calendars.store] Auth and user ID confirmed, loading selected calendars...'
    );
    await loadStoredSelectedCalendars(force, reload);
  } catch (error) {
    console.error('[selected.calendars.store] Error loading selected calendars:', error);
    // Don't throw the error to prevent breaking the app flow
  }
};

export const enabledCalendars = derived(
  [selectedCalendarsView, providerCalendars],
  ([$selectedCalendarsView, $providerCalendars]) => {
    if (!$providerCalendars || !Object.values($providerCalendars).length) {
      return [];
    }

    const disabledCalendarIds: string[] = $selectedCalendarsView.disabledCalendarIds ?? [];

    const allCalendars: ProviderCalendar[] = Object.values($providerCalendars).flat();

    const enabled = allCalendars.filter((calendar) => {
      return !disabledCalendarIds.includes(calendar.id);
    });

    return enabled;
  }
);

// Export idiomatic methods
export {
  loadStoredSelectedCalendars,
  safeLoadStoredSelectedCalendars,
  selectedCalendarsView,
  setSelectedCalendarsView
};
